<div class="form-container">
  <ws10-grid>
    <ws10-grid-column [gridColumnConfig]="gridColumns[1]">
      <ws10-text-header class= "centerHub-header__cont" [textHeaderConfig]="textHeaderConfig"></ws10-text-header>
        </ws10-grid-column>
</ws10-grid>
<ws10-grid-container>
  <!-- start-search-input  -->
<div class="search-bar" *ngIf ="allformsArray && allformsArray.length > formsCount">
<ws10-grid>
<ws10-grid-column [gridColumnConfig]="gridColumns[2]">
<h3 class="search-label" [innerHtml]="'FromCenterModule.hubPage.searchBarContent.std-headline'| translate"></h3>
</ws10-grid-column>

<ws10-grid-column [gridColumnConfig]="gridColumns[3]">
<ws10-search-input ng-class= "ws10-column ws10-column--8"
(onTriggerNewSearchQueryUpdate)="FliterFormList($event)"
[searchInputConfig]="searchInputConfig">
</ws10-search-input>
</ws10-grid-column>
</ws10-grid>
</div>
<!-- end-search-input  -->

<!-- start forms array -->
<span *ngIf = "formsArray && formsArray.length > 1">{{paginationFormsArray.length}}
  <span class="conuter-number" [innerHtml]="'FromCenterModule.hubPage.counter.std-headline'| translate"></span>
</span>
<span *ngIf = "formsArray && formsArray.length ===1">{{paginationFormsArray.length}}
  <span class="conuter-number" [innerHtml]="'FromCenterModule.hubPage.counter.std-subHeadline'| translate"></span>
</span>
<br><br><br>
<ws10-grid>
<ws10-grid-column [gridColumnConfig]="gridColumns[4]">
<ws10-list-card-wrapper-brix *ngFor ="let form of formsArray; let i = index">
  <ws10-list-card-brix
  [listCardConfig]="form">
  </ws10-list-card-brix>
  </ws10-list-card-wrapper-brix>
  <!-- ws10-pagination  -->
  <ws10-pagination *ngIf="this.paginationFormsArray.length > 10"
    [pagination]="paginationData"
    (nextPage)="onNextPage()"
    (prevPage)="onPrevPage()"
    ></ws10-pagination>
    <br>
  <!-- ws10-pagination  -->
</ws10-grid-column>
</ws10-grid>
<!-- end forms array -->


<!-- start for error msgs-->
<ws10-grid>
    <ws10-grid-column  [gridColumnConfig]="gridColumns[5]">
        <div>
        </div>
    </ws10-grid-column>
    <ws10-grid-column  [gridColumnConfig]="gridColumns[6]">
          <!-- div for no search result available Msg -->
            <div *ngIf="formsArray.length === 0 && allformsArray.length !== 0" class="text-center">
              <div class="error-icon-wrapper custom-icon-wrapper">
                    <svg class="form-icon i-lrg">
                        <use xlink:href="/simplicity/simplicity-smaller/svgs/svgdefs.svg#i-search-mid-lrg" />
                      </svg>
                    </div>
                  <div class="general-error-text-wrapper">
                     <h3 [innerHtml]="'FromCenterModule.hubPage.noSearchResultMsg.std-headline' | translate"></h3>
                  </div>
            </div>
            <!-- div for noforms available Msg -->
            <div *ngIf="allformsArray && allformsArray.length === 0"   class="text-center">
                <svg class=" mid icon-plus-i-lrg i-lrg" ><use xlink:href="/simplicity/simplicity-smaller/svgs/svgdefs.svg#i-case-study-mid-lrg" /></svg>
                <div class="eq-body">
                    <h3 class= "center-footer" [innerHtml]="'FromCenterModule.hubPage.noAvailableItemsMsg.std-headline' | translate"></h3>
                </div>
            </div>

    </ws10-grid-column>
  </ws10-grid>
  <!-- end nosearch available Msg -->
</ws10-grid-container>
</div>








